import apiPaths from '../api-paths.js';

export default {
  listByOwner() {
    const personId = JSON.parse(localStorage.getItem('person')).id;
    return axios.get(`${ apiPaths.PERSON }/addressesbyowner/${ personId }?list`);
  },
  listByPerson(personId) {
    return axios.get(`${ apiPaths.PERSON }/addressesbyperson/${ personId }?list`);
  },
  store(data) {
    return axios.post(`${ apiPaths.PERSON }/addresses`, { address: data });
  },
  show(id) {
    return axios.get(`${ apiPaths.PERSON }/addresses/${ id }`);
  },
  update(data) {
    return axios.put(`${ apiPaths.PERSON }/addresses/${ data.id }`, { address: data });
  },
  delete(id) {
    return axios.delete(`${ apiPaths.PERSON }/addresses/${ id }`);
  },
};
